import React, { useState } from 'react';
import Input from 'antd/lib/input';

import './searchInput.css';

interface Props {
  handleSearchInput: (value: string) => void;
}

const SearchInput = ({ handleSearchInput }: Props) => {
  const [value, setValue] = useState('');

  return (
    <Input
      style={{
        width: '200px',
        marginRight: '8px',
      }}
      allowClear
      placeholder="Search"
      value={value}
      className="deeds-search-input"
      onBlur={() => {
        handleSearchInput(value);
      }}
      onChange={(event) => {
        setValue(event.target.value);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.target.blur();
        }
      }}
    />
  );
};

export default SearchInput;
